function extractGitHubInfo(url) {
  const regex = /https:\/\/([^\/]+)\/([^\/]+)\/([^\/]+)\/tree\/([^\/]+)(?:\/(.*))?\/([^\/]+)$/;
  const match = url.match(regex);
  if (!match) {
    throw new Error("URL inv\xE1lida");
  }
  const [_, host, owner, repo, branch, path, file] = match;
  return {
    host,
    owner,
    repo,
    branch,
    path: path || "",
    file
  };
}

export { extractGitHubInfo };
//# sourceMappingURL=extractGithubInfo.esm.js.map
